import React, { CSSProperties } from 'react';

import {
  MAXIMUM_TABLES_REACHED_MESSAGE,
  MAXIMUM_TABLES_REACHED_MESSAGE_NO_WAITLIST,
  OKAY_BUTTON,
  TABLE_LIMIT_TITLE
} from 'constants/waitlistStrings';

import GameModal, { btnRowStyle, primaryBtnStyle } from 'components/GameModal/GameModal';

/**
 * Unity parity: shown when a player tries to join more than the allowed
 * number of active tables. Call sites in Unity:
 *   - UICashGame.cs:240
 *   - UITableWaitListPreview.cs:239
 *   - LobbiesViewPortraitAdapter.cs:378
 *   - LobbiesViewCellChildAdapter.cs:912
 *
 * Title, both body variants, and button label match GameConstants.cs verbatim.
 * Built on the shared branded GameModal (dark navy + gold) like the other
 * system modals.
 */
type MaximumTablesReachedAlertProps = {
  open: boolean;
  waitlistEnabled: boolean;
  onClose: () => void;
};

const MaximumTablesReachedAlert: React.FC<MaximumTablesReachedAlertProps> = ({
  open,
  waitlistEnabled,
  onClose
}) => {
  const message = waitlistEnabled
    ? MAXIMUM_TABLES_REACHED_MESSAGE
    : MAXIMUM_TABLES_REACHED_MESSAGE_NO_WAITLIST;
  return (
    <GameModal
      open={open}
      onClose={onClose}
      title={TABLE_LIMIT_TITLE}
      // Tapping outside dismisses (EN-10789): `onClose` is the same handler the
      // OKAY button runs, and it only lowers the alert flag.
      showClose={false}>
      <div style={messageStyle}>{message}</div>
      <div style={btnRowStyle}>
        <button onClick={onClose} style={primaryBtnStyle} aria-label='close-max-tables'>
          {OKAY_BUTTON}
        </button>
      </div>
    </GameModal>
  );
};

export default MaximumTablesReachedAlert;

const messageStyle: CSSProperties = {
  fontSize: '0.95rem',
  color: 'rgba(255, 255, 255, 0.7)',
  lineHeight: 1.5,
  textAlign: 'center',
  marginBottom: '0.5rem'
};
